module.exports = __webpack_public_path__ + "media/images/sp/top/recommend-plan-text-maedori2-f9b9bbad9d43a17b40c0c64ab7667cb3.png";